// Real catalogue imagery, pulled from the same brand/maker/category records the
// app itself renders. Brand logos go through require.context so dropping a new
// file into src/assets/brands picks it up without touching this file — only the
// display label and the featured ordering below are curated by hand.

import hyundai from 'assets/makers/hyundai.jpg';
import kia from 'assets/makers/kia.jpg';
import daewooChevrolet from 'assets/makers/daewoo-chevrolet.jpg';
import ssangyong from 'assets/makers/ssangyong.jpg';
import nissan from 'assets/makers/nissan.jpg';

import brakePads from 'assets/categories/brake-pads.jpg';
import belts from 'assets/categories/belts.jpg';
import airFilter from 'assets/categories/air-filter.jpg';
import fuelFilter from 'assets/categories/fuel-filter.jpg';
import cabinFilter from 'assets/categories/cabin-filter.jpg';

export const MAKERS = [
  { slug: 'hyundai', latin: 'HYUNDAI', ar: 'هيونداي', src: hyundai },
  { slug: 'kia', latin: 'KIA', ar: 'كيا', src: kia },
  { slug: 'daewoo-chevrolet', latin: 'DAEWOO · CHEVROLET', ar: 'دايو وشيفروليه', src: daewooChevrolet },
  { slug: 'ssangyong', latin: 'SSANGYONG', ar: 'سانج يونج', src: ssangyong },
  { slug: 'nissan', latin: 'NISSAN', ar: 'نيسان', src: nissan },
];

export const CATEGORIES = [
  { slug: 'brake-pads', ar: 'اطقم تيل', src: brakePads },
  { slug: 'belts', ar: 'سيور', src: belts },
  { slug: 'air-filter', ar: 'فلتر هواء', src: airFilter },
  { slug: 'fuel-filter', ar: 'فلتر بنزين', src: fuelFilter },
  { slug: 'cabin-filter', ar: 'فلتر تكييف', src: cabinFilter },
];

// Slugs whose display label is not just the uppercased filename.
const BRAND_LABELS = {
  eldoctor: 'EL DOCTOR',
  'genuine-kia': 'GENUINE KIA',
  'mobis-kia': 'MOBIS KIA',
  gy: 'G.Y',
  sgg: 'S.G.G.',
  wsw: 'W.S.W',
  oem: 'OEM',
  korean: 'KOREAN',
};

// The names a visitor is most likely to recognise lead the wall; everything else
// follows in alphabetical order.
const FEATURED = [
  'denso',
  'valeo',
  'hella',
  'gates',
  'skf',
  'fag',
  'mando',
  'mobis',
  'gmb',
  'ctr',
  'iljin',
  'doowon',
  'beru',
  'hanon',
  'shell',
  'gm',
  'genuine-kia',
  'eldoctor',
];

const context = require.context('../../assets/brands', false, /\.(png|jpe?g|gif|webp)$/);

const all = context.keys().map((key) => {
  const slug = key.replace(/^\.\//, '').replace(/\.\w+$/, '');
  // file-loader emits an ES module here, so the URL sits on `.default`; the
  // fallback covers a CommonJS loader config.
  const asset = context(key);
  return {
    slug,
    label: BRAND_LABELS[slug] || slug.replace(/-/g, ' ').toUpperCase(),
    src: asset && asset.default ? asset.default : asset,
  };
});

const bySlug = all.reduce((acc, brand) => Object.assign(acc, { [brand.slug]: brand }), {});

export const BRAND_LOGOS = [
  ...FEATURED.map((slug) => bySlug[slug]).filter(Boolean),
  ...all.filter((brand) => !FEATURED.includes(brand.slug)).sort((a, b) => a.slug.localeCompare(b.slug)),
];
